import React, { useState } from "react";
import { TextInput, View } from "react-native";
import { StyledText } from "../common/ui/styled-text";
import { displayPrice } from "../../utils/price-helpers";

export default function CurrencyInput({
  value,
  onChangeValue,
  maxAmount,
}: {
  value: number;
  onChangeValue: (value: number) => void;
  maxAmount?: number;
}) {
  const MAX_LENGTH = 7; // under $1k only
  const [display, setDisplay] = useState(formatCurrency(value));
  const [showMaxWarning, setShowMaxWarning] = useState(false);

  function formatCurrency(cents: number) {
    if (cents == null) return "";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(cents / 100);
  }

  function parseCurrency(text: string) {
    const clean = text.replace(/\D/g, ""); // remove all non-digits
    return clean ? parseInt(clean, 10) : 0;
  }

  function handleChange(text: string) {
    let newValue = parseCurrency(text);
    if (!!maxAmount && newValue > maxAmount) {
      newValue = maxAmount;
      setShowMaxWarning(true);
    } else {
      setShowMaxWarning(false);
    }
    setDisplay(formatCurrency(newValue));
    onChangeValue(newValue); // give back cents
  }

  return (
    <View className="p-2">
      <TextInput
        className="p-3 text-lg border border-gray-300 rounded-lg bg-white"
        keyboardType="numeric"
        value={display}
        onChangeText={handleChange}
        placeholder="$0.00"
        maxLength={MAX_LENGTH}
      />
      {showMaxWarning && !!maxAmount && (
        <StyledText className="text-xs text-red-600 mt-1 font-medium">
          You cannot enter more than {displayPrice(maxAmount)}
        </StyledText>
      )}
    </View>
  );
}
